export const STAGES = [
  { key: "yeni_basvuru", label: "Yeni Başvuru" },
  { key: "on_gorusme", label: "Ön Görüşme" },
  { key: "aktif_danisan", label: "Aktif Danışan" },
  { key: "calisma_hazirlaniyor", label: "Çalışma Hazırlanıyor" },
  { key: "gonderildi", label: "Gönderildi" },
  { key: "takip", label: "Takip" },
  { key: "tamamlandi", label: "Tamamlandı" },
  { key: "arsiv", label: "Arşiv" },
];

export const STAGE_MAP = STAGES.reduce((acc, s) => {
  acc[s.key] = s.label;
  return acc;
}, {});

export const ROLE_LABEL = {
  admin: "Admin",
  danisman: "Danışman",
  operasyon: "Operasyon",
};

export const SOURCE_LABEL = {
  web_form: "Web Formu",
  instagram: "Instagram",
  referans: "Referans",
  telefon: "Telefon",
  diger: "Diğer",
};

export const WORK_KINDS = {
  meditasyon: "Meditasyon",
  rehberlik: "Rehberlik",
  dua: "Dua",
  ritual: "Ritüel",
};

export const WORK_STATUS = {
  hazirlaniyor: "Hazırlanıyor",
  gonderildi: "Gönderildi",
  tamamlandi: "Tamamlandı",
  iptal: "İptal",
};

export const APPT_TYPE = {
  on_gorusme: "Ön Görüşme",
  seans: "Seans",
  takip: "Takip",
};

export const APPT_STATUS = {
  planlandi: "Planlandı",
  tamamlandi: "Tamamlandı",
  iptal: "İptal",
};

export function formatDate(iso, opts = {}) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("tr-TR", {
    day: "2-digit",
    month: "short",
    year: opts.withYear ? "numeric" : undefined,
  });
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("tr-TR", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });
}

export function currencyTRY(n) {
  return new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(n || 0);
}

export function initials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}
